import { render } from "./payRemarkModel.vue?vue&type=template&id=fee02c16"
import script from "./payRemarkModel.vue?vue&type=script&lang=js"
export * from "./payRemarkModel.vue?vue&type=script&lang=js"

import "./payRemarkModel.vue?vue&type=style&index=0&id=fee02c16&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__